import React from 'react';
import { Link } from 'react-router-dom';
import '../css/notfound.css'; 

const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-message">Page Not Found</p>
        <p className="not-found-description">
          Sorry, the page you requested does not exist or has been moved.
        </p>
        <Link to="/" className="not-found-link">
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;